<app-loading-indicator />

<!-- <router-outlet /> -->
<app-main-layout></app-main-layout>

<p-toast
  [baseZIndex]="1101"
  position="top-right">
  <ng-template
    let-message
    pTemplate="message">
    <div class="p-toast-summary">{{ message.summary }}</div>
    <div
      [innerHTML]="message.detail"
      class="p-toast-detail"></div>
  </ng-template>
</p-toast>

<app-confirm-dialog></app-confirm-dialog>
